/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Processing_Item_UsageInputs */

const en_privacy_data_processing_item_usage = /** @type {(inputs: Privacy_Data_Processing_Item_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage data:`)
};

const de_privacy_data_processing_item_usage = /** @type {(inputs: Privacy_Data_Processing_Item_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsdaten:`)
};

const fr_privacy_data_processing_item_usage = /** @type {(inputs: Privacy_Data_Processing_Item_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données d'utilisation :`)
};

const es_privacy_data_processing_item_usage = /** @type {(inputs: Privacy_Data_Processing_Item_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de uso:`)
};

const it_privacy_data_processing_item_usage = /** @type {(inputs: Privacy_Data_Processing_Item_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati di utilizzo:`)
};

const nl_privacy_data_processing_item_usage = /** @type {(inputs: Privacy_Data_Processing_Item_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruiksgegevens:`)
};

const pl_privacy_data_processing_item_usage = /** @type {(inputs: Privacy_Data_Processing_Item_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane o użytkowaniu:`)
};

const fi_privacy_data_processing_item_usage = /** @type {(inputs: Privacy_Data_Processing_Item_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käyttötiedot:`)
};

const da_privacy_data_processing_item_usage = /** @type {(inputs: Privacy_Data_Processing_Item_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brugsdata:`)
};

const sv_privacy_data_processing_item_usage = /** @type {(inputs: Privacy_Data_Processing_Item_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Användardata:`)
};

/**
* | output |
* | --- |
* | "Usage data:" |
*
* @param {Privacy_Data_Processing_Item_UsageInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_processing_item_usage = /** @type {((inputs?: Privacy_Data_Processing_Item_UsageInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Processing_Item_UsageInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_processing_item_usage(inputs)
	if (locale === "fr") return fr_privacy_data_processing_item_usage(inputs)
	if (locale === "es") return es_privacy_data_processing_item_usage(inputs)
	if (locale === "it") return it_privacy_data_processing_item_usage(inputs)
	if (locale === "nl") return nl_privacy_data_processing_item_usage(inputs)
	if (locale === "pl") return pl_privacy_data_processing_item_usage(inputs)
	if (locale === "fi") return fi_privacy_data_processing_item_usage(inputs)
	if (locale === "da") return da_privacy_data_processing_item_usage(inputs)
	if (locale === "sv") return sv_privacy_data_processing_item_usage(inputs)
	return en_privacy_data_processing_item_usage(inputs)
});